const initialState = {
  anchor: 'left',
  empresa: [],
  open: false,
  id: 0,
  razaoSocial: '',
  nomeFantasia: '',
  cpf: '',
  cnpj: '',
  telefone: '',
  celular: '',
  email: '',
  endereco: '',
  idCidade: 0,
  idEstado: 0,
  inscricaoEstadual: '',
  informacoesCobranca: '',
  usuariosEmpresas: [],
  empresasAnexos: [],
  empresasOrgaos: [],
  empresasTiposServicos: [],
  empresasTiposVeiculos: [],
  cidade: [],
  totalRegistros: 0,
  autonomo: false,
  fornecedor: false,
  mediaNota: 0,
  totalAvaliacoes: 0,
  prestadorServico: false,
  cadastroLiberado: false,
  aceiteTermos: false,
  limiteOrcamentosOrdemServico: 0
}

export function empresa(state = initialState, action) {
  switch (action.type) {
    case 'EMPRESA_DETAIL':
      return {
        ...state,
        id: action.id,
        razaoSocial: action.razaoSocial,
        nomeFantasia: action.nomeFantasia,
        cnpj: action.cnpj,
        cpf: action.cpf,
        telefone: action.telefone,
        celular: action.celular,
        email: action.email,
        endereco: action.endereco,
        idCidade: action.idCidade,
        idEstado: action.idEstado,
        inscricaoEstadual: action.inscricaoEstadual,
        informacoesCobranca: action.informacoesCobranca,
        usuariosEmpresas: action.usuariosEmpresas,
        empresasAnexos: action.empresasAnexos,
        empresasTiposServicos: action.empresasTiposServicos,
        empresasTiposVeiculos: action.empresasTiposVeiculos,
        empresasOrgaos: action.empresasOrgaos,
        fornecedor: action.fornecedor,
        autonomo: action.autonomo,
        cidade: action.cidade,
        prestadorServico: action.prestadorServico,
        cadastroLiberado: action.cadastroLiberado,
        aceiteTermos: action.aceiteTermos,
        mediaNota: action.mediaNota,
        limiteOrcamentosOrdemServico: action.limiteOrcamentosOrdemServico,
        totalAvaliacoes: action.totalAvaliacoes,
        totalRegistros: action.totalRegistros
      }
    case 'EMPRESA_UPDATED':
      return state
    case 'EMPRESA_CLEAR':
      return initialState
    case 'EMPRESA_CLEAR_ALL':
      return {
        ...state,
        empresa: []
      }
    case 'EMPRESA_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'EMPRESA_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    case 'EMPRESA_CLEAR_USUARIOS_EMPRESAS':
      return {
        ...state,
        usuariosEmpresas: []
      }
    case 'EMPRESA_CLEAR_TIPOS_VEICULOS':
      return {
        ...state,
        empresasTiposVeiculos: []
      }
    case 'EMPRESA_CLEAR_TIPOS_SERVICOS':
      return {
        ...state,
        empresasTiposServicos: []
      }
    case 'FETCHED_ALL_EMPRESA':
      return {
        ...state,
        empresa: action.empresa,
        totalRegistros: action.totalRegistros
      }
    case 'EMPRESA_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    default:
      return state
  }
}
